export default __webpack_public_path__ + "static/media/fallout-item-4.856bff26.png";